export interface NavItem {
  id: string;
  type: 'item' | 'group';
  title: string;
  url?: string;
  icon?: string;
  /** SVG url drawn in the text colour via mask; used instead of icon. */
  svgIcon?: string;
  children?: NavItem[];
  disabled?: boolean;
  action?: (context?: any | undefined) => void;
  badge?: {
    title: string;
    backgroundColor?: string;
    color?: string;
  };

}

export const BASE_NAV_ITEMS: NavItem[] = [
  {
    id: 'manage',
    type: 'group',
    title: 'Manage My TAs',
    icon: 'fa fa-create',
    children: [
      {
        id: 'my-tas',
        type: 'item',
        title: 'My Travel Allowances',
        url: '/home',
        icon: 'fa-light fa-location-dot',
      }
    ]
  },
];

export const BASE_MANAGE_ITEM: NavItem = {
  id: 'approval',
  type: 'group',
  title: 'TA Management',
  icon: 'pi pi-cog',
  children: [],
};

export const BASE_ADMIN_ITEM: NavItem = {
  id: 'admin',
  type: 'group',
  title: 'TA Admin',
  icon: 'pi pi-cog',
  children: [],
};

export const AVAILABLE_MANAGE_ITEMS: NavItem[] = [
  {
    id: 'my-tas-approval',
    type: 'item',
    title: 'Approvals Dashboard',
    url: '/approvals',
    icon: 'fa-light fa-list-check',
  },
  {
    id: 'manager-dashboard',
    type: 'item',
    title: 'Manager Dashboard',
    url: '/manager-dashboard',
    icon: 'fa-light fa-user-tie',
  },
  {
    id: 'compliance-dashboard',
    type: 'item',
    title: 'Compliance Dashboard',
    url: '/compliance-dashboard',
    icon: 'fa-light fa-shield-check',
  },
  {
    id: 'finance-dashboard',
    type: 'item',
    title: 'Finance Dashboard',
    url: '/finance-dashboard',
    icon: 'fa-light fa-dollar-sign',
  }
]

export const AVAILABLE_ADMIN_ITEMS: NavItem[] = [
  {
    id: 'admin-users',
    type: 'item',
    title: 'Users',
    url: '/admin/users',
    icon: 'fa-light fa-users',
  },
  {
    id: 'admin-locations',
    type: 'item',
    title: 'Locations',
    url: '/admin/locations',
    icon: 'fa-light fa-map-location-dot',
  },
  {
    id: 'admin-clc-tiers',
    type: 'item',
    title: 'CLC Tiers',
    url: '/admin/clc-tiers',
    icon: 'fa-light fa-chart-area',
  },
  {
    id: 'admin-unit-project',
    type: 'item',
    title: 'Units and Projects',
    url: '/admin/units-projects',
    icon: 'fa-light fa-diagram-project',
  },
  {
    id: 'system-admin',
    type: 'item',
    title: 'System',
    url: '/admin/system',
    icon: 'fa-light fa-cog',
  }
];

export const BASE_INFO_ITEMS: NavItem[] = [

  {
    id: 'info',
    type: 'group',
    title: 'Information',
    children: [
      {
        id: 'info-userManual',
        type: 'item',
        title: 'User Manual (PDF)',
        action: () => window.open('/clcta/file/help-manual', '_blank'),
        icon: 'fa-light fa-circle-question',
      },
      {
        id: 'info-releaseNotes',
        type: 'item',
        title: 'Release Notes',
        url: '/releasenotes',
        icon: 'fa-light fa-notes',
      }
    ]
  }
];
